import pageTitle from './pageTitle';
import pageConfig from './pageConfig';
import pageGroup from './pageGroup';

const view = name => (resolve) => {
    require([`@/views/${name}/index.vue`], resolve); // eslint-disable-line
};

// const view = name => () => import(`@/views/${name}/index.vue`);

const meta = page => Object.assign(
    {},
    {
        title: pageTitle[page] || '页面未命名',
        pageId: pageConfig[page] || '',
        pageGroup: pageGroup[page] || '',
    },
);

// 写出来到这里, 打包的时候会根据这些结构进行拆分文件
const home              = view('home');
const incomeOverview    = view('incomeOverview');
const incomeList        = view('incomeList');
const login             = view('login');
const open              = view('open');
const openCard          = view('openCard');
const orderDetail       = view('orderDetail');
const orderEdit         = view('orderEdit');
const orderList         = view('orderList');
const storeCardEdit     = view('storeCardEdit');
const pageNotFound      = view('pageNotFound');
const systemMaintenance = view('systemMaintenance');
const client            = view('client');
const clientDetail      = view('clientDetail');
const cars              = view('cars');
const carsDetail        = view('carsDetail');
const prePaidEdit       = view('prePaidEdit');
const prePaidCrt        = view('prePaidCrt');
const prePaid           = view('prePaid');
const prePaidRecord     = view('prePaidRecord');
const clientPromot      = view('clientPromot');
const staffEdit         = view('staffEdit');
const staffList         = view('staffList');
const roleList          = view('roleList');
const roleEdit          = view('roleEdit');
const operators         = view('operators');
const notice            = view('notice');
const noticeDetail      = view('noticeDetail');
const logList           = view('logList');
const predict           = view('predict');
const printOrder        = view('printOrder');
const printStoreDetail  = view('printStoreDetail');
const historyList       = view('historyList');
// const workerOrderList   = view('workerOrderList');
// const workerOrderDetail = view('workerOrderDetail');
const selfGoods         = view('selfGoods');
const agencyGoods       = view('agencyGoods');
const enterStore        = view('enterStore');
const selfGoodsEdit     = view('selfGoodsEdit');
const outStore          = view('outStore');
const addAgencyGoods    = view('addAgencyGoods');
const enterStoreDetail  = view('enterStoreDetail');
const outStoreDetail    = view('outStoreDetail');
const serverReserve     = view('serverReserve');
const dataOverview      = view('dataOverview');
const analyseGoods      = view('analyseGoods');
const analyseRepairCard = view('analyseRepairCard');
const analyseSalesActivity = view('analyseSalesActivity');
const analyseStoreCard  = view('analyseStoreCard');
const analyseCustomer   = view('analyseCustomer');
const carsExamReport    = view('carsExamReport');
const addCarExam        = view('addCarExam');
const carsInspectionTemplate = view('carsInspectionTemplate');
const carsInspectionTemplateEdit = view('carsInspectionTemplateEdit');
const carsHistory = view('carsHistory');
const carsHistoryDetails = view('carsHistoryDetails');
const carExamEdit = view('carExamEdit');
const printExam = view('printExam');
const checkCarExam = view('checkCarExam');
const serviceList = view('serviceList');
const serviceEdit = view('serviceEdit');
const writeoffList = view('writeoffList');
const writeoffDetail = view('writeoffDetail');
const maintenancePlan = view('maintenancePlan');
const maintenanceRecord = view('maintenanceRecord');
const maintenanceRecordDetails = view('maintenanceRecordDetails');
const editCoupon = view('editCoupon');
const seeCoupon = view('seeCoupon');
const couponList = view('couponList');
const couponOwner = view('couponOwner');
const couponLaunch = view('couponLaunch');
const analyseCoupon = view('analyseCoupon');
const vipExplain = view('vipExplain');
const orderSetting = view('orderSetting');

// 一级路由权限id
export const groupAuthId = {
    open: '1', // 收银
    card: '2', // 营销
    service: '151', // 服务
    client: '3', // 客户
    store: '78', // 库存
    list: '4', // 收益
    member: '5', // 员工
    auth: '6', // 设置

};

// 默认路由
export const routes = [
    {
        path: '/',
        redirect: '/home',
    },
    {
        path: '/home',
        group: 'home',
        name: 'home',
        meta: meta('home'),
        component: home
    },
    // 登录
    {
        path: '/login',
        group: null,
        name: 'login',
        meta: meta('login'),
        component: login
    },
    // vip内容介绍
    {
        path: '/vipExplain',
        group: null,
        name: 'vipExplain',
        meta: meta('vipExplain'),
        component: vipExplain
    },
    // 404 页面
    {
        path: '*',
        group: null,
        name: 'pageNotFound',
        meta: meta('pageNotFound'),
        component: pageNotFound
    },
];

// 所有路由
export const authRoutes = [
    {
        path: '/',
        redirect: '/home',
    },
    {
        path: '/home',
        group: 'home',
        name: 'home',
        meta: meta('home'),
        component: home
    },
    // 登录
    {
        path: '/login',
        group: null,
        name: 'login',
        meta: meta('login'),
        component: login
    },
    // 收益记录
    {
        path: '/incomeList',
        group: 'list',
        name: 'incomeList',
        meta: meta('incomeList'),
        component: incomeList
    },
    // 普通开单
    {
        path: '/open',
        group: 'open',
        name: 'open',
        meta: meta('open'),
        component: open
    },
    // 收银订单详情
    {
        path: '/orderDetail',
        group: null,
        name: 'orderDetail',
        meta: meta('orderDetail'),
        component: orderDetail
    },
    {
        path: '/carHistoryOrderDetail',
        group: null,
        name: 'carHistoryOrderDetail',
        meta: meta('carHistoryOrderDetail'),
        component: orderDetail
    },
    // 收益记录详情
    {
        path: '/profitOrderDetail',
        group: null,
        name: 'profitOrderDetail',
        meta: meta('profitOrderDetail'),
        component: orderDetail
    },
    // // 接车订单详情
    // {
    //     path: '/workerOrderDetail',
    //     group: null,
    //     name: 'workerOrderDetail',
    //     meta: meta('workerOrderDetail'),
    //     component: workerOrderDetail
    // },
    // 历史导入数据
    {
        path: '/historyList',
        group: null,
        name: 'historyList',
        meta: meta('historyList'),
        component: historyList
    },
    // 收银开单编辑
    {
        path: '/orderEdit',
        group: null,
        name: 'orderEdit',
        meta: meta('orderEdit'),
        component: orderEdit
    },
    // 爱车卡
    {
        path: '/openCard',
        group: 'card',
        name: 'openCard',
        meta: meta('openCard'),
        component: openCard
    },
    // 营销售卡编辑
    {
        path: '/storeCardEdit',
        group: null,
        name: 'storeCardEdit',
        meta: meta('storeCardEdit'),
        component: storeCardEdit
    },
    {
        // 储值卡开单
        path: '/prePaid',
        group: 'card',
        name: 'prePaid',
        meta: meta('prePaid'),
        component: prePaid
    },
    {
        // 储值卡编辑
        path: '/prePaidEdit',
        group: null,
        name: 'prePaidEdit',
        meta: meta('prePaidEdit'),
        component: prePaidEdit
    },
    {
        // 储值卡记录
        path: '/prePaidRecord',
        group: null,
        name: 'prePaidRecord',
        meta: meta('prePaidRecord'),
        component: prePaidRecord
    },
    {
        path: '/prePaidCrt',
        group: null,
        name: 'prePaidCrt',
        meta: meta('prePaidCrt'),
        component: prePaidCrt
    },
    {
        // 保养营销
        path: '/clientPromot',
        group: 'card',
        name: 'clientPromot',
        meta: meta('clientPromot'),
        component: clientPromot
    },
    {
        // 自营商品
        path: '/selfGoods',
        group: 'store',
        name: 'selfGoods',
        meta: meta('selfGoods'),
        component: selfGoods
    },
    {
        // 自营商品edit
        path: '/selfGoodsEdit',
        group: null,
        name: 'selfGoodsEdit',
        meta: meta('selfGoodsEdit'),
        component: selfGoodsEdit
    },
    {
        path: '/predict',
        group: 'card',
        name: 'predict',
        meta: meta('predict'),
        component: predict
    },
    // 客户管理
    {
        path: '/client',
        group: 'client',
        name: 'client',
        meta: meta('client'),
        component: client
    },
    // 客户详情
    {
        path: '/clientDetail',
        group: null,
        name: 'clientDetail',
        meta: meta('clientDetail'),
        component: clientDetail
    },
    // 车辆管理
    {
        path: '/cars',
        group: 'client',
        name: 'cars',
        meta: meta('cars'),
        component: cars,
    },
    // 车辆详情
    {
        path: '/carsDetail',
        group: null,
        name: 'carsDetail',
        meta: meta('carsDetail'),
        component: carsDetail,
    },
    // 员工管理
    {
        path: '/operators',
        group: 'member',
        name: 'operators',
        meta: meta('operators'),
        component: operators,
    },
    // 角色管理
    {
        path: '/staffList',
        group: 'auth',
        name: 'staffList',
        meta: meta('staffList'),
        component: staffList,
    },
    {
        path: '/staffEdit',
        group: null,
        name: 'staffEdit',
        meta: meta('staffEdit'),
        component: staffEdit,
    },
    {
        path: '/roleList',
        group: 'auth',
        name: 'roleList',
        meta: meta('roleList'),
        component: roleList,
    },
    {
        path: '/roleEdit',
        group: null,
        name: 'roleEdit',
        meta: meta('roleEdit'),
        component: roleEdit,
    },
    {
        path: '/logList',
        group: 'auth',
        name: 'logList',
        meta: meta('logList'),
        component: logList,
    },
    // 系统通知
    {
        path: '/notice',
        group: null,
        name: 'notice',
        meta: meta('notice'),
        component: notice,
    },
    {
        path: '/noticeDetail',
        group: null,
        name: 'noticeDetail',
        meta: meta('noticeDetail'),
        component: noticeDetail,
    },
    {
        path: '/printOrder',
        group: null,
        name: 'printOrder',
        meta: meta('printOrder'),
        component: printOrder,
    },
    {
        path: '/printStoreDetail',
        group: null,
        name: 'printStoreDetail',
        meta: meta('printStoreDetail'),
        component: printStoreDetail,
    },
    // 收银列表
    {
        path: '/orderList',
        group: 'open',
        name: 'orderList',
        meta: meta('orderList'),
        component: orderList
    },
    // // 接车列表
    // {
    //     path: '/workerOrderList',
    //     group: 'open',
    //     name: 'workerOrderList',
    //     meta: meta('workerOrderList'),
    //     component: workerOrderList
    // },
    {// 车检报告
        path: '/carsExamReport',
        group: 'open',
        name: 'carsExamReport',
        meta: meta('carsExamReport'),
        component: carsExamReport
    },
    {// 新增车检
        path:'/addCarExam',
        group:null,
        name:'addCarExam',
        meta:meta('addCarExam'),
        component:addCarExam
    },
    {
        // 代理商品
        path: '/agencyGoods',
        group: 'store',
        name: 'agencyGoods',
        meta: meta('agencyGoods'),
        component: agencyGoods
    },
    {
        // 入库
        path: '/enterStore',
        group: 'store',
        name: 'enterStore',
        meta: meta('enterStore'),
        component: enterStore
    },
    {
        // 出库
        path: '/outStore',
        group: 'store',
        name: 'outStore',
        meta: meta('outStore'),
        component: outStore
    },
    {
        // 入库详情
        path: '/enterStoreDetail',
        group: null,
        name: 'enterStoreDetail',
        meta: meta('enterStoreDetail'),
        component: enterStoreDetail
    },
    {
        // 出库详情
        path: '/outStoreDetail',
        group: null,
        name: 'outStoreDetail',
        meta: meta('outStoreDetail'),
        component: outStoreDetail
    },
    {
        path: '/carsHistory',
        group: null,
        name: 'carsHistory',
        meta: meta('carsHistory'),
        component: carsHistory
    },
    {
        path: '/carsHistoryDetails',
        group: null,
        name: 'carsHistoryDetails',
        meta: meta('carsHistoryDetails'),
        component: carsHistoryDetails
    },
    {
        // 车检模板
        path: '/carsInspectionTemplate',
        group: 'auth',
        name: 'carsInspectionTemplate',
        meta: meta('carsInspectionTemplate'),
        component: carsInspectionTemplate
    },
    {
        // 编辑车检模板
        path: '/carsInspectionTemplateEdit',
        group: null,
        name: 'carsInspectionTemplateEdit',
        meta: meta('carsInspectionTemplateEdit'),
        component: carsInspectionTemplateEdit
    },
    {
        // 车检详情
        path:'/checkCarExam',
        group:null,
        name:'checkCarExam',
        meta:meta('checkCarExam'),
        component:checkCarExam
    },
    {// 打印车检报告
        path:'/printExam',
        group:null,
        name:'printExam',
        meta:meta('printExam'),
        component:printExam
    },
    {// 编辑车检报告
        path:'/carExamEdit',
        group:null,
        name:'carExamEdit',
        meta:meta('carExamEdit'),
        component:carExamEdit
    },
    // 添加代理商品
    {
        path: '/addAgencyGoods',
        group: addAgencyGoods,
        name: 'addAgencyGoods',
        meta: meta('addAgencyGoods'),
        component: addAgencyGoods
    },
    // 数据概览
    {
        path: '/dataOverview',
        group: 'list',
        name: 'dataOverview',
        meta: meta('dataOverview'),
        component: dataOverview
    },
    // 收益统计
    {
        path: '/incomeOverview',
        group: 'list',
        name: 'incomeOverview',
        meta: meta('incomeOverview'),
        component: incomeOverview
    },
    // 商品分析
    {
        path: '/analyseGoods',
        group: 'list',
        name: 'analyseGoods',
        meta: meta('analyseGoods'),
        component: analyseGoods
    },
    // 爱车卡分析
    {
        path: '/analyseRepairCard',
        group: 'list',
        name: 'analyseRepairCard',
        meta: meta('analyseRepairCard'),
        component: analyseRepairCard
    },
    // 营销活动分析
    {
        path: '/analyseSalesActivity',
        group: 'list',
        name: 'analyseSalesActivity',
        meta: meta('analyseSalesActivity'),
        component: analyseSalesActivity
    },
    // 储值卡分析
    {
        path: '/analyseStoreCard',
        group: 'list',
        name: 'analyseStoreCard',
        meta: meta('analyseStoreCard'),
        component: analyseStoreCard
    },
    // 服务预约分析
    {
        path: '/serverReserve',
        group: 'list',
        name: 'serverReserve',
        meta: meta('serverReserve'),
        component: serverReserve
    },
    // 客户分析
    {
        path: '/analyseCustomer',
        group: 'list',
        name: 'analyseCustomer',
        meta: meta('analyseCustomer'),
        component: analyseCustomer
    },
    {
        path: '/systemMaintenance',
        group: 'null',
        name: 'systemMaintenance',
        meta: meta('systemMaintenance'),
        component: systemMaintenance
    },
    {
        path: '/serviceList',
        group: 'service',
        name: 'serviceList',
        meta: meta('serviceList'),
        component: serviceList
    },
    {
        path: '/serviceEdit',
        group: '',
        name: 'serviceEdit',
        meta: meta('serviceEdit'),
        component: serviceEdit
    },
    { // 保养方案
        path: '/maintenancePlan',
        group: '',
        name: 'maintenancePlan',
        meta: meta('maintenancePlan'),
        component: maintenancePlan
    },
    { // 保养营销记录
        path: '/maintenanceRecord',
        group: 'card',
        name: 'maintenanceRecord',
        meta: meta('maintenanceRecord'),
        component: maintenanceRecord
    },
    { // 保养营销记录详情
        path: '/maintenanceRecordDetails',
        group: '',
        name: 'maintenanceRecordDetails',
        meta: meta('maintenanceRecordDetails'),
        component: maintenanceRecordDetails
    },
    { // 核销记录
        path: '/writeoffList',
        group: 'list',
        name: 'writeoffList',
        meta: meta('writeoffList'),
        component: writeoffList
    },
    { // 核销记录详情
        path: '/writeoffDetail',
        group: '',
        name: 'writeoffDetail',
        meta: meta('writeoffDetail'),
        component: writeoffDetail
    }, // 核销记录详情
    {
        path: '/editCoupon',
        group: '',
        name: 'editCoupon',
        meta: meta('editCoupon'),
        component: editCoupon
    }, // 新建/编辑/复制优惠券
    {
        path: '/seeCoupon',
        group: '',
        name: 'seeCoupon',
        meta: meta('seeCoupon'),
        component: seeCoupon
    }, // 查看优惠券
    {
        path: '/couponList',
        group: 'card',
        name: 'couponList',
        meta: meta('couponList'),
        component: couponList
    }, // 优惠券
    {
        path: '/couponOwner',
        group: '',
        name: 'couponOwner',
        meta: meta('couponOwner'),
        component: couponOwner
    }, // 领券车主
    {
        path: '/couponLaunch',
        group: '',
        name: 'couponLaunch',
        meta: meta('couponLaunch'),
        component: couponLaunch
    }, // 发放优惠券
    {
        path: '/analyseCoupon',
        group: 'list',
        name: 'analyseCoupon',
        meta: meta('analyseCoupon'),
        component: analyseCoupon
    }, // 优惠券分析
    { // vip内容介绍
        path: '/vipExplain',
        group: null,
        name: 'vipExplain',
        meta: meta('vipExplain'),
        component: vipExplain
    },
    {
        path: '/orderSetting',
        group: 'auth',
        name: 'orderSetting',
        meta: meta('orderSetting'),
        component: orderSetting
    },
    // 404 页面, 放置最后
    {
        path: '*',
        group: null,
        name: 'pageNotFound',
        meta: meta('pageNotFound'),
        component: pageNotFound
    },
];



// WEBPACK FOOTER //
// ./src/router/routes.js